// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2361": "d11dc508","2895": "fa85db70","5545": "20927b2f",}[chunkId] + ".css"
}